<span>{{ 'AITopic::TopicTrainingFailedMessage' | abpLocalization : message }}</span>
